// Single source of truth for the app's brand typography (per client):
//   Body    → Work Sans
//   Heading → Montserrat
// Both web fonts are loaded in public/index.html. The "Fallback" names + the
// system stack keep text readable until the web font finishes loading.
//
// Use BODY_FONT for normal text (this is also the MUI theme default, so most
// components inherit it automatically) and HEADING_FONT for page titles and
// section / card headings.
export const BODY_FONT =
  "'Work Sans', 'Work Sans Fallback', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif";

export const HEADING_FONT =
  "'Montserrat', 'Montserrat Fallback', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif";
